import MuiBaseModal from "../../common/modal/MuiModal";
import { ISectionSchema } from "../../../services/Schemas/Role";
import CreateAccessForm from "../../../forms/access-edit-create/CreateAccessForm";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  handleReload?: () => void;
  roleInfo?: ISectionSchema;
  open: boolean;
}

export default function CreateAccessModal({
  onClose,
  open,
  roleInfo,
  handleReload,
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={roleInfo ? "ویرایش دسترسی" : "ایجاد دسترسی"}
      hasCloseIcon
    >
      <CreateAccessForm
        roleInfo={roleInfo}
        onSuccess={() => {
          onClose(false);
          handleReload && handleReload();
        }}
      />
    </MuiBaseModal>
  );
}
